import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const permissionsApi = createApi({
  reducerPath: "permissionsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Permissions"],
  endpoints: (builder) => ({
    getPermissions: builder.query({
      query: (userId) => `/permissions/${userId}`,
      providesTags: (result, error, userId) => [{ type: "Permissions", id: userId }],
    }),
    updatePermissions: builder.mutation({
      query: ({ userId, ...data }) => ({ url: `/permissions/${userId}`, method: "PUT", body: data }),
      invalidatesTags: (result, error, { userId }) => [{ type: "Permissions", id: userId }],
    }),
    resetPermissions: builder.mutation({
      query: ({ userId, role }) => ({ url: `/permissions/${userId}/reset`, method: "POST", body: { role } }),
      invalidatesTags: (result, error, { userId }) => [{ type: "Permissions", id: userId }],
    }),
  }),
});

export const { useGetPermissionsQuery, useUpdatePermissionsMutation, useResetPermissionsMutation } = permissionsApi;
